module.exports = __webpack_public_path__ + "static/media/VoucherPdfHero.7719ae99.jpg";